import React from 'react'

import '../scss/WarningIcon.scss'

const WarningIcon = () => <div className="WarningIcon">Warning!</div>

export default WarningIcon
